<template>
  <div class="main">

    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24">
          <div class="dashboard">

            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24">
                <c-panel title="Utilização do sistema" titleIcon="fas fa-chart-line">
                  <div class="chart-box chart-box--lg">
                    <mixed-bar-line-chart class="chart-canvas" :chart-data="chartUtilizacao"></mixed-bar-line-chart>
                  </div>
                </c-panel>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12">
                <c-panel title="Quantidade de alunos por idade" titleIcon="fas fa-user-graduate">
                  <div class="chart-box chart-box--md">
                    <bar-chart class="chart-canvas" :chart-data="chartIdade"></bar-chart>
                  </div>
                </c-panel>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12">
                <c-panel title="Alunos da zona rural e urbana" titleIcon="fas fa-map-marked-alt">
                  <div class="chart-box chart-box--md">
                    <doughnut-chart class="chart-canvas" :chart-data="chartZona"></doughnut-chart>
                  </div>
                </c-panel>
              </el-col>
            </el-row>

          </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
    BarChart: () => import('@/chart/BarChart'),
    MixedBarLineChart: () => import('@/chart/MixedBarLineChart'),
    DoughnutChart: () => import('@/chart/DoughnutChart')
  },
  data: () => ({
    chartUtilizacao: {
      labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      datasets: [
        {
          label: 'Acessos (sessões)',
          type: 'bar',
          data: [820, 910, 1260, 1180, 1420, 1610, 1540, 1730, 1680, 1820, 1950, 2140],
          yAxisID: 'y-sessoes',
          backgroundColor: 'rgba(52, 109, 170, 0.35)',
          borderColor: '#346daa',
          borderWidth: 1
        },
        {
          label: 'Usuários ativos (dia)',
          type: 'line',
          data: [120, 135, 180, 165, 210, 240, 230, 260, 255, 275, 290, 320],
          yAxisID: 'y-ativos',
          borderColor: '#50964d',
          backgroundColor: 'rgba(80, 150, 77, 0.15)',
          pointBackgroundColor: '#50964d',
          pointBorderColor: '#50964d',
          fill: false,
          lineTension: 0.25,
          borderWidth: 2
        }
      ]
    },
    chartIdade: {
      labels: ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18'],
      datasets: [
        {
          label: 'Alunos',
          data: [32, 48, 71, 95, 110, 130, 142, 151, 147, 138, 120, 98, 76, 41, 18],
          backgroundColor: '#346daa'
        }
      ]
    },
    chartZona: {
      labels: ['Urbana', 'Rural'],
      datasets: [
        {
          label: 'Alunos',
          data: [1240, 460],
          backgroundColor: ['#50964d', '#f5a623'],
          borderColor: ['#50964d', '#f5a623'],
          borderWidth: 1
        }
      ]
    }
  })
}
</script>

<style scoped>
.dashboard {
  padding: 10px 0;
}

.chart-box {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.chart-box--lg {
  /* o line-chart mantém aspectRatio, então altura muito grande pode "esticar" visualmente */
  height: 320px;
}

.chart-box--md {
  height: 320px;
}

.chart-canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}

.chart-box ::v-deep canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>